import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_77vus6wgqz: FaireBrandEntity = {
  token: "b_77vus6wgqz",
  type: "brand",
  name: "Yammy",
  avatarUrl:
    "https://cdn.faire.com/fastly/1c5acaf30f95dd67f2537ecd78df8e7e95b328619dbf0c991f5a52bff273c8ef.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0df3b7d84b818157ca519c0d839c7f4e8bc1238882c521eadb283c8c39c26a6c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1c5acaf30f95dd67f2537ecd78df8e7e95b328619dbf0c991f5a52bff273c8ef.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0df3b7d84b818157ca519c0d839c7f4e8bc1238882c521eadb283c8c39c26a6c.png",
  location: "Fremont, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.8,
  reviewCount: 20,
  isInsider: true,
  description:
    "Snacking just got a whole lot simpler.\n\nLet's be real about snacking. We've all been there – standing in the snack category, forced to choose between \"tastes amazing but full of junk\" or \"healthy but tastes like cardboard.\" It's the ultimate snacking dilemma. Why should satisfying your cravings mean sacrificing your wellbeing? We refused to accept this false choice.\n\nYammy's on a mission to make healthy snacking actually fun. We do that by drawing from culturally-inspired family traditions, using ridiculously simple ingredients (sweet potatoes + real spices), and creating a uniquely chewy texture that keeps you satisfied for hours (think of this as nature's gummy candy). No compromises, just snacks that respect both your cravings and your body.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:18.010Z",
    importedBy: "entity-db-cli",
  },
};
